module.exports = __webpack_public_path__ + "static/endeavor-0bb8146418cfdc9babb8c69171b57bc7.png";